var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * @class
 * @description Shaka loader class. It receives shaka object and player and listen/modifies the requests.
 * @exports LoaderShaka
 */
export default class LoaderShaka {
    /**
     * Constructs ShakaLoader.
     * @param {Object} shakaObject Shaka constructor reference.
     */
    constructor(shakaObject) {
        this._active = false;
        this._shaka = shakaObject;
        this._requestTypes = this._shaka.net.NetworkingEngine.RequestType;
        this.register();
    }
    /**
     * Listens NetworkingEngine requests from shaka to manage and redirect them.
     * @public
     */
    register() {
        if (!this._active) {
            ['http', 'https'].forEach((e) => {
                this._shaka.net.NetworkingEngine.registerScheme(e, this._requestListener.bind(this));
            });
            this._active = true;
        }
    }
    /**
     * Stops to listen NetworkingEngine requests from shaka, sets the default http(s) plugin instead.
     * @public
     */
    unregister() {
        if (this._active) {
            ['http', 'https'].forEach((e) => {
                const a = this._shaka.net.HttpXHRPlugin.parse || this._shaka.net.HttpXHRPlugin;
                this._shaka.net.NetworkingEngine.registerScheme(e, a.bind(this));
            });
            this._active = false;
        }
    }
    /**
     * Network events from shaka callback.
     * @param {string} url Request url.
     * @param {Object} req Request object.
     * @param {string} reqType Request type.
     * @param {Object} progUpdated ProgressUpdated.
     * @returns {Object} Created request
     * @private
     */
    _requestListener(url, req, reqType, progUpdated) {
        const shakaxhr = this._shaka.net.HttpXHRPlugin.parse || this._shaka.net.HttpXHRPlugin;
        switch (reqType) {
            case this._requestTypes.MANIFEST:
                LoaderShaka._engine.setManifestResource(url);
            // eslint-disable-next-line no-fallthrough
            case this._requestTypes.SEGMENT:
                // eslint-disable-next-line no-case-declarations
                return new this._shaka.util.AbortableOperation(this._loadSegment(url, req), () => __awaiter(this, void 0, void 0, function* () {
                    // Nothing
                }));
        }
        // eslint-disable-next-line no-case-declarations
        return shakaxhr(url, req, reqType, progUpdated);
    }
    /**
     * Method to request segments.
     * @param {string} url Request url.
     * @param {Object} req Request object.
     * @returns {Promise} Promise with the request of the segment.
     * @private
     * @async
     */
    _loadSegment(url, req) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const begin = Date.now();
                LoaderShaka._engine.request(new URL(url), true, [
                    (e) => {
                        resolve({
                            Od: url,
                            data: e.data,
                            timeMs: Date.now() - begin,
                            uri: url
                        });
                    }
                ], req.headers, undefined, true);
            });
        });
    }
}
